import { FilterStoreHook } from 'libs/end-to-end/src/filters-v2/types/filters-v2.types';
import { FilterStoreValue } from 'libs/end-to-end/src/filters-v2/types/filters-v2.types';
import { PrimaryFilterKey } from 'libs/end-to-end/src/filters-v2/types/filters-v2.types';
import { DimensionDefinition } from 'libs/end-to-end/src/types/databases/dimensions/dimension-definition';
import { LevelDefinition } from 'libs/end-to-end/src/types/databases/dimensions/level-definition';
import { determineCanClearAllSecondaryFilters } from 'libs/end-to-end/src/filters-v2/filter-utils';
import { EntitledDetailsInContextOfFiltersFeatureName } from 'libs/end-to-end/src/filters-v2/filter-utils';
import { determineSecondaryFilterDefinitionsForFeature } from 'libs/end-to-end/src/filters-v2/filter-utils';
import { determineSecondaryFilterSelections } from 'libs/end-to-end/src/filters-v2/filter-utils';
import { PrimaryFilterSelection } from 'libs/end-to-end/src/filters-v2/filter-utils';
import { determineDefaultValueForSecondaryFilter } from 'libs/end-to-end/src/filters-v2/filter-utils';
import { FiltersFeatureName } from 'libs/end-to-end/src/filters-v2/filter-utils';
import { getPrimaryFilterFullKey } from 'libs/end-to-end/src/filters-v2/filter-utils';
import { getSecondaryFilterFullKey } from 'libs/end-to-end/src/filters-v2/filter-utils';
import { getSelectedSecondaryFilterValue } from 'libs/end-to-end/src/filters-v2/filter-utils';
import { isFilterStoreValueEqual } from 'libs/end-to-end/src/filters-v2/filter-utils';
import { SecondaryFilterSelection } from 'libs/end-to-end/src/filters-v2/filter-utils';
import { FocusArea } from 'libs/end-to-end/src/focus-area';
import { MyObservation } from 'libs/end-to-end/src/my-observation';
import { HorizontalFilterBarItemProps } from 'apps/sigma2-ui/src/filters-v2/components/HorizontalFilterBar';
import { PrimaryFilterMenu } from 'apps/sigma2-ui/src/filters-v2/components/PrimaryFilterMenu';
import { getIconForPrimaryFilterButton } from 'apps/sigma2-ui/src/filters-v2/lib/filter-utils';
import { getTranslationsForPrimaryFilterButton } from 'apps/sigma2-ui/src/filters-v2/lib/filter-utils';
import { getTranslationsForSecondaryFilterChip } from 'apps/sigma2-ui/src/filters-v2/lib/filter-utils';
import { PrimaryFilterButton } from 'apps/sigma2-ui/src/filters-v2/components/PrimaryFilterButton';
import { SecondaryFilterChip } from 'apps/sigma2-ui/src/filters-v2/components/SecondaryFilterChip';
import { SecondaryFilterButton } from 'apps/sigma2-ui/src/filters-v2/components/SecondaryFilterButton';
import { SecondaryFiltersMenu } from 'apps/sigma2-ui/src/filters-v2/components/SecondaryFiltersMenu';
import React from 'react';
import { MetricDefinitionWhiteLabeling } from 'libs/end-to-end/src/types/databases/metrics/metric-definition';
import { DownloadAnalysisButton } from 'apps/sigma2-ui/src/filters-v2/components/DownloadAnalysisButton';
import { MyMetricDefinition } from 'libs/end-to-end/src/my-metric-definition';
import { CalibrationFraming } from 'libs/end-to-end/src/calibration-framing';
import { isEntitledToDashboards } from 'libs/end-to-end/src/group-entitlements';
import { isEntitledToSavedAnalysis } from 'libs/end-to-end/src/group-entitlements';
import { Phrases } from 'libs/end-to-end/src/phrases';
import { CustomVizRequest } from 'libs/end-to-end/src/custom-viz/CustomVizRequest';
import { DateRangeMenu } from 'apps/sigma2-ui/src/filters-v2/components/DateRangeMenu';
import { ChartTypeSegmentedControl } from 'apps/sigma2-ui/src/filters-v2/components/ChartTypeSegmentedControl';
import { isDashboardsEnabledForRevision } from 'libs/end-to-end/src/common-revision-flags';
import { isEventStudyEnabledForRevision } from 'libs/end-to-end/src/common-revision-flags';
import { FilterDefinitionForExtrasArray } from 'libs/end-to-end/src/types/databases/filters/filter-definition';

// eslint-disable-next-line complexity
export const determineFilterBarItems = ({
  feature,
  focusArea,
  store,
  organizationId,
  databaseId,
  databaseRevisionId,
  getAllLevelsForDimension,
  getLevelByColumnValue,
  allDimensions,
  entitledFilterFeatureDetails,
  primaryFilterKeys,
  primaryFilterSelections,
  setPrimaryFilters,
  resetFiltersToInitialState,
  resetSecondaryFiltersToDefault,
  setSecondaryFilters,
  myObservation,
  stagingSecondaryFilters,
  resetStagingSecondaryFilters,
  setStagingSecondaryFilter,
  clearAllItem,
  saveAnalysisItem,
  addToDashboardItem,
  setSelectedSecondaryFilterKey,
  selectedSecondaryFilterKey,
  disabled,
  metricWhiteLabeling,
  downloadEnabled,
  isDownloading,
  downloadCallback,
  analysisName,
  calibrationFraming,
  language,
  customVizRequest,
  dashboardGlobalFilters,
}: {
  primaryFilterKeys: PrimaryFilterKey[];
  primaryFilterSelections: PrimaryFilterSelection[];
  allDimensions: DimensionDefinition[];
  entitledFilterFeatureDetails: EntitledDetailsInContextOfFiltersFeatureName;
  getAllLevelsForDimension: (columnHeaderValue: string) => LevelDefinition[];
  getLevelByColumnValue: (
    columnHeaderValue: string,
    columnValue: string,
  ) => LevelDefinition | undefined;
  store: FilterStoreHook;
  feature: FiltersFeatureName;
  focusArea: FocusArea | null;
  metricWhiteLabeling: MetricDefinitionWhiteLabeling | null;
  organizationId: string;
  databaseId: string;
  databaseRevisionId: string;
  setPrimaryFilters: (params: {
    selections: PrimaryFilterSelection[];
    shouldPreventAutoSubmit?: boolean;
  }) => void;
  resetFiltersToInitialState: (
    selectionsToPreserve?: PrimaryFilterSelection[],
  ) => void;
  resetSecondaryFiltersToDefault: (newFocusArea: FocusArea) => void;
  setSecondaryFilters: (params: {
    selections: SecondaryFilterSelection[];
    shouldPreventAutoSubmit?: boolean;
  }) => void;
  myObservation: MyObservation | null;
  stagingSecondaryFilters: SecondaryFilterSelection[];
  resetStagingSecondaryFilters: () => void;
  setStagingSecondaryFilter: (params: {
    secondaryFilterKey: string;
    value: FilterStoreValue;
  }) => void;
  clearAllItem: HorizontalFilterBarItemProps;
  saveAnalysisItem: HorizontalFilterBarItemProps;
  addToDashboardItem: HorizontalFilterBarItemProps;
  selectedSecondaryFilterKey: string | null;
  setSelectedSecondaryFilterKey: (key: string | null) => void;
  disabled: boolean;
  downloadEnabled: boolean;
  isDownloading: boolean;
  downloadCallback: () => void;
  analysisName: string | undefined;
  calibrationFraming: CalibrationFraming;
  language: Phrases;
  customVizRequest: CustomVizRequest | undefined;
  dashboardGlobalFilters: FilterDefinitionForExtrasArray;
}): HorizontalFilterBarItemProps[] => {
  const canClearAllSecondaryFilters = determineCanClearAllSecondaryFilters({
    databaseId,
    databaseRevisionId,
    feature,
    focusArea,
    myObservation,
    organizationId,
    store,
    analysisName,
  });

  const secondaryFilterDefinitions =
    determineSecondaryFilterDefinitionsForFeature({
      feature,
      focusArea,
      focusAreas: myObservation?.focusAreas ?? [],
      filterSetDefinitionsWithValues:
        myObservation?.filterSetDefinitionsWithValues ?? [],
      dimensionDefinitions: allDimensions,
      pipelineAnalysisConfiguration:
        myObservation?.pipelineAnalysisConfiguration,
      analysisName,
    });

  const isEventStudyEnabled = isEventStudyEnabledForRevision({
    revisionFlags: myObservation,
  });

  const allItems: HorizontalFilterBarItemProps[] = [];

  for (const primaryFilterKey of primaryFilterKeys) {
    if (primaryFilterKey === 'dateRange') {
      allItems.push({
        key: getPrimaryFilterFullKey({ primaryFilterKey }),
        content: () => (
          <DateRangeMenu
            store={store}
            feature={feature}
            organizationId={organizationId}
            databaseId={databaseId}
            databaseRevisionId={databaseRevisionId}
            focusArea={focusArea}
            analysisName={analysisName}
            closeMenu={() => {}}
            setPrimaryFilters={setPrimaryFilters}
          />
        ),
        menu: () => <></>,
      });
      continue;
    } else if (primaryFilterKey === 'chartType') {
      allItems.push({
        key: getPrimaryFilterFullKey({ primaryFilterKey }),
        content: () => (
          <ChartTypeSegmentedControl
            store={store}
            feature={feature}
            organizationId={organizationId}
            databaseRevisionId={databaseRevisionId}
            databaseId={databaseId}
            focusArea={focusArea}
            setPrimaryFilters={setPrimaryFilters}
            analysisName={analysisName}
          />
        ),
        menu: () => <></>,
      });
    }

    if (feature === 'timeSeriesTrendsPrimary' && !isEventStudyEnabled) {
      if (
        primaryFilterKey === 'singleDate' ||
        primaryFilterKey === 'eventStudyGroup'
      ) {
        continue;
      }
    }

    allItems.push({
      key: getPrimaryFilterFullKey({ primaryFilterKey }),
      menu: ({ closeMenu }) => {
        return (
          <PrimaryFilterMenu
            primaryFilterKey={primaryFilterKey}
            allDimensions={allDimensions}
            entitledFilterFeatureDetails={entitledFilterFeatureDetails}
            getAllLevelsForDimension={getAllLevelsForDimension}
            store={store}
            feature={feature}
            organizationId={organizationId}
            databaseId={databaseId}
            databaseRevisionId={databaseRevisionId}
            focusArea={focusArea}
            closeMenu={closeMenu}
            setPrimaryFilters={setPrimaryFilters}
            resetFiltersToInitialState={resetFiltersToInitialState}
            resetSecondaryFiltersToDefault={resetSecondaryFiltersToDefault}
            primaryFilterSelections={primaryFilterSelections}
            myObservation={myObservation}
            secondaryFilterDefinitions={secondaryFilterDefinitions}
            analysisName={analysisName}
          />
        );
      },
      content: ({ menuOpened, openMenu, disabled: disabledByCaller }) => {
        const translations = getTranslationsForPrimaryFilterButton({
          primaryFilterKey,
          store,
          feature,
          focusArea,
          analysisName,
          databaseRevisionId,
          databaseId,
          organizationId,
          getLevelByColumnValue,
          whiteLabelForMetric: metricWhiteLabeling,
          myObservation,
          calibrationFraming,
          allDimensions,
          secondaryFilterDefinitions,
          entitledFilterFeatureDetails,
          language,
        });

        if (!translations) {
          return null;
        }

        return (
          <PrimaryFilterButton
            onClick={() => {
              openMenu();
            }}
            disabled={
              disabledByCaller
                ? true
                : primaryFilterKey === 'comparisonGroup'
                  ? true
                  : disabled
            }
            active={menuOpened}
            hasSelection={translations.hasSelection}
            leftTranslatedContent={translations.leftTranslatedContent}
            rightTranslatedContent={translations.rightTranslatedContent}
            icon={getIconForPrimaryFilterButton({ primaryFilterKey })}
          />
        );
      },
    });
  }

  for (const secondaryFilterDefinition of secondaryFilterDefinitions) {
    const currentValueGlobalDashboard =
      dashboardGlobalFilters.find(
        (f) =>
          f.columnHeaderValue === secondaryFilterDefinition.columnHeaderValue,
      )?.values ?? null;

    const currentValue =
      currentValueGlobalDashboard !== null
        ? currentValueGlobalDashboard
        : getSelectedSecondaryFilterValue({
            secondaryFilterKey: secondaryFilterDefinition.columnHeaderValue,
            store,
            organizationId,
            focusArea,
            analysisName,
            databaseId,
            databaseRevisionId,
            feature,
          });

    if (currentValue === null) {
      continue;
    }

    const defaultValue = determineDefaultValueForSecondaryFilter({
      secondaryFilterKey: secondaryFilterDefinition.columnHeaderValue,
      myObservation,
      focusArea,
      feature,
      analysisName,
    });

    if (
      defaultValue === null ||
      isFilterStoreValueEqual(currentValue, defaultValue)
    ) {
      continue;
    }

    const fullKey = getSecondaryFilterFullKey({
      secondaryFilterKey: secondaryFilterDefinition.columnHeaderValue,
    });

    allItems.push({
      key: fullKey,
      content: ({ menuOpened, openMenu }) => {
        const currentValueGlobalDashboard =
          dashboardGlobalFilters.find(
            (f) =>
              f.columnHeaderValue ===
              secondaryFilterDefinition.columnHeaderValue,
          )?.values ?? null;

        const currentValue =
          currentValueGlobalDashboard !== null
            ? currentValueGlobalDashboard
            : getSelectedSecondaryFilterValue({
                store,
                feature,
                focusArea,
                analysisName,
                databaseId,
                databaseRevisionId,
                organizationId,
                secondaryFilterKey: secondaryFilterDefinition.columnHeaderValue,
              });

        const translations = getTranslationsForSecondaryFilterChip({
          secondaryFilterKey: secondaryFilterDefinition.columnHeaderValue,
          feature,
          focusArea,
          analysisName,
          myObservation,
          language,
          currentValue,
        });

        if (!translations) {
          return null;
        }

        const canDismiss = !dashboardGlobalFilters.some(
          (f) =>
            f.columnHeaderValue === secondaryFilterDefinition.columnHeaderValue,
        );

        return (
          <SecondaryFilterChip
            disabled={disabled}
            active={menuOpened}
            hasSelection={true}
            icon={null}
            canDismiss={canDismiss}
            onDismiss={() => {
              const current = determineSecondaryFilterSelections({
                myObservation,
                focusArea,
                feature,
                store,
                organizationId,
                databaseId,
                databaseRevisionId,
                analysisName,
              });

              const newSelections: SecondaryFilterSelection[] = current.map(
                (item) =>
                  item.secondaryFilterKey ===
                  secondaryFilterDefinition.columnHeaderValue
                    ? {
                        ...item,
                        value: defaultValue,
                      }
                    : item,
              );

              setSecondaryFilters({
                selections: newSelections,
              });
            }}
            onClick={() => {
              resetStagingSecondaryFilters();
              setSelectedSecondaryFilterKey(
                secondaryFilterDefinition.columnHeaderValue,
              );
              openMenu();
            }}
            leftTranslatedContent={translations.leftTranslatedContent}
            rightTranslatedContent={translations.rightTranslatedContent}
          />
        );
      },
      menu: ({ closeMenu }) => {
        return (
          <SecondaryFiltersMenu
            closeMenu={closeMenu}
            setSecondaryFilters={setSecondaryFilters}
            feature={feature}
            secondaryFilterDefinitions={secondaryFilterDefinitions}
            focusArea={focusArea}
            stagingSecondaryFilters={stagingSecondaryFilters}
            setStagingSecondaryFilter={setStagingSecondaryFilter}
            myObservation={myObservation}
            selectedSecondaryFilterKey={selectedSecondaryFilterKey}
            setSelectedSecondaryFilterKey={setSelectedSecondaryFilterKey}
            analysisName={analysisName}
            dashboardGlobalFilters={dashboardGlobalFilters}
          />
        );
      },
    });
  }

  if (secondaryFilterDefinitions.length > 0) {
    allItems.push({
      key: 'secondaryFilters',
      content: ({ openMenu, menuOpened }) => (
        <SecondaryFilterButton
          disabled={disabled}
          active={menuOpened}
          translatedContent={
            canClearAllSecondaryFilters
              ? language.secondaryFilterButtonEditText()
              : language.secondaryFilterButtonText()
          }
          onClick={() => {
            resetStagingSecondaryFilters();
            setSelectedSecondaryFilterKey(
              secondaryFilterDefinitions[0].columnHeaderValue,
            );
            openMenu();
          }}
        />
      ),
      menu: ({ closeMenu }) => (
        <SecondaryFiltersMenu
          closeMenu={closeMenu}
          setSecondaryFilters={setSecondaryFilters}
          feature={feature}
          secondaryFilterDefinitions={secondaryFilterDefinitions}
          focusArea={focusArea}
          stagingSecondaryFilters={stagingSecondaryFilters}
          setStagingSecondaryFilter={setStagingSecondaryFilter}
          myObservation={myObservation}
          selectedSecondaryFilterKey={selectedSecondaryFilterKey}
          setSelectedSecondaryFilterKey={setSelectedSecondaryFilterKey}
          analysisName={analysisName}
          dashboardGlobalFilters={dashboardGlobalFilters}
        />
      ),
    });
  }

  if (canClearAllSecondaryFilters) {
    allItems.push(clearAllItem);
  }

  const showSavedAnalysisPage = myObservation?.showSavedAnalysesPage ?? false;
  const showDashboardsPage = isDashboardsEnabledForRevision({
    revisionFlags: myObservation,
  });

  if (
    showSavedAnalysisPage &&
    isEntitledToSavedAnalysis({ features: myObservation?.features ?? [] }) &&
    customVizRequest?.customVizId !== undefined &&
    customVizRequest.customVizId !== 'richText'
  ) {
    allItems.push(saveAnalysisItem);
  }
  if (
    showDashboardsPage &&
    isEntitledToDashboards({
      features: myObservation?.features ?? [],
    })
  ) {
    allItems.push(addToDashboardItem);
  }

  if (downloadEnabled) {
    allItems.push({
      content: () => (
        <DownloadAnalysisButton
          disabled={isDownloading}
          onClick={downloadCallback}
        />
      ),
      menu: () => <></>,
      key: 'downloadAnalysis',
    });
  }

  return allItems;
};
